// Shared, framework-free constants and helpers for the Optimiser readiness UI.
// Kept free of React/antd imports so the page, the block dialog and the badge
// can all reuse them without pulling in extra dependencies.

export const STATUS_PATH = '/manage/optimiser-status/';

export const RECORD_TYPES = {
  USER: 'user',
  ACTIVITY: 'activity'
};

export const ERROR_TYPES = {
  MISSING_FIELD: 'missing_field',
  MISSING_TAG: 'missing_tag',
  INVALID_VALUE: 'invalid_value'
};

export const RECORD_TYPE_LABELS = {
  user: 'User',
  activity: 'Activity',
  assignment: 'Assignment'
};

export const ERROR_TYPE_LABELS = {
  missing_field: 'Missing field',
  missing_tag: 'Missing tag',
  invalid_value: 'Invalid value'
};

export const RECORD_TYPE_OPTIONS = [
  { value: RECORD_TYPES.USER, label: RECORD_TYPE_LABELS.user },
  { value: RECORD_TYPES.ACTIVITY, label: RECORD_TYPE_LABELS.activity }
];

export const ERROR_TYPE_OPTIONS = [
  { value: ERROR_TYPES.MISSING_FIELD, label: ERROR_TYPE_LABELS.missing_field },
  { value: ERROR_TYPES.MISSING_TAG, label: ERROR_TYPE_LABELS.missing_tag },
  { value: ERROR_TYPES.INVALID_VALUE, label: ERROR_TYPE_LABELS.invalid_value }
];

export const recordTypeLabel = value => RECORD_TYPE_LABELS[value] || value;

export const errorTypeLabel = value => ERROR_TYPE_LABELS[value] || value;

export const BROKER_STATE = {
  healthy: { label: 'Healthy', colour: '#389e0d', bg: '#f6ffed' },
  unhealthy: { label: 'Unreachable', colour: '#cf1322', bg: '#fff1f0' },
  unknown: { label: 'Unknown', colour: '#bfbfbf', bg: '#fafafa' }
};

export const brokerStateLabel = state => (BROKER_STATE[state] || BROKER_STATE.unknown);

export const RUN_STATE = {
  running: { label: 'Running', colour: '#fa8c16' },
  queued: { label: 'Queued', colour: '#fa8c16' },
  idle: { label: 'Idle', colour: '#8c8c8c' },
  finished: { label: 'Finished', colour: '#389e0d' },
  failed: { label: 'Failed', colour: '#cf1322' },
  cancelled: { label: 'Cancelled', colour: '#722ed1' },
  unknown: { label: 'Unknown', colour: '#bfbfbf' }
};

export const runStateLabel = state => (RUN_STATE[state] || RUN_STATE.unknown);

export const RUN_RESULT = {
  completed: { label: 'Completed', tag: 'green' },
  failed: { label: 'Failed', tag: 'red' },
  cancelled: { label: 'Cancelled', tag: 'purple' }
};

export const runResultLabel = result => (RUN_RESULT[result] || RUN_RESULT.failed);

export const WRITEBACK_STATE = {
  applied: { label: 'Applied', colour: '#389e0d', tag: 'green' },
  failed: { label: 'Failed', colour: '#cf1322', tag: 'red' },
  // A row still in 'received' has been accepted but not yet applied by the worker.
  received: { label: 'Processing', colour: '#fa8c16', tag: 'orange' },
  none: { label: 'None received', colour: '#8c8c8c', tag: null }
};

export const writebackStateLabel = status => (WRITEBACK_STATE[status] || WRITEBACK_STATE.none);

// Where each failing record is edited. The SPA has no per-id deep link for
// users/activities, so we point at the relevant management list. That keeps
// "summary -> drill-down -> edit" within two clicks (FR-3.1).
export const editPathForRecord = (recordType) => {
  if (recordType === RECORD_TYPES.ACTIVITY) {
    return '/roster/activities/';
  }
  return '/manage/users/';
};
